/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { UpdateAssetTypeMutation, UpdateAssetTypeMutationVariables } from "@models/graphql";

const defaultUpdateAssetTypeOptions: MutationHookOptions<UpdateAssetTypeMutation, UpdateAssetTypeMutationVariables> = {};

export const useUpdateAssetType = (options?: MutationHookOptions<UpdateAssetTypeMutation, UpdateAssetTypeMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<UpdateAssetTypeMutation, UpdateAssetTypeMutationVariables>(
        GraphQLDocuments.updateAssetType
    );

    const updateAssetType = async (variables: UpdateAssetTypeMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultUpdateAssetTypeOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        updateAssetType
    };
};
